import { create } from 'zustand'

export interface SnackbarOptions {
  timeout?: number
  onClose?: () => void
  dataTestId?: string
}

interface SnackbarState {
  message: string
  variant: 'success' | 'error'
  options?: SnackbarOptions
}

interface SnackbarStore {
  snackbar: SnackbarState | null
  showSuccessSnackbar: (message: string, options?: SnackbarOptions) => void
  showErrorSnackbar: (message: string, options?: SnackbarOptions) => void
  closeSnackbar: () => void
}

export const useSnackbarStore = create<SnackbarStore>()((set, get) => ({
  snackbar: null,

  showSuccessSnackbar: (message, options) => set({ snackbar: { message, variant: 'success', options } }),

  showErrorSnackbar: (message, options) => set({ snackbar: { message, variant: 'error', options } }),

  closeSnackbar: () => {
    get().snackbar?.options?.onClose?.()
    set({ snackbar: null })
  },
}))
